import React from 'react';

export default function SectionWrapper({ children, className = '' }) {
  return (
    <section className={`mx-auto mt-14 max-w-6xl px-6 ${className}`.trim()}>
      {children}
    </section>
  );
}

